import React from "react";

import {
  Button,
  Form,
  FormGroup,
  Label,
  Col,
  Container,
  Row, FormText
} from "reactstrap";

import SelectListComponent from "../utils/selectList";
import DateSelector from "../utils/dateSelector";
import {appConstants} from '../../_constants';

const WalletPanel = ({
  airlines,
  handleSelectChange,
  SourceAirlineId,
  handleDateChange,
  componentErrorMessages,
  onSearch,
  user,
  startDateChange,
  endDateChange
}) => {
  return (
    <Form onSubmit={e => e.preventDefault()}>
      <Container>
        <Row>
        <Col xs="6" sm="3">
            <FormGroup className={"mb-0 " + (componentErrorMessages.SourceAirlineId ? 'has-danger' : '')}>
              <Label>Airline</Label>
              {(user.OrganizationType === appConstants.ORGANIZATIONS.OTHERS) ?
              <SelectListComponent 
              // placeholder={'Select airline...'} 
              data={airlines} 
              valueKey='Id' 
              textField='Name' 
              selectValue={SourceAirlineId} 
              disabled={true}
              // onValueChange={(event) => { handleSelectChange(event, 'SourceAirlineId') }}
              />
              :
              <SelectListComponent 
              placeholder={'Select airline...'} 
              data={airlines} 
              valueKey='Id' 
              textField='Name' 
              selectValue={SourceAirlineId} 
              onValueChange={(event) => { handleSelectChange(event, 'SourceAirlineId') }} />
              }
            {componentErrorMessages.SourceAirlineId && <FormText color="danger"> {componentErrorMessages.SourceAirlineId}</FormText>}
            </FormGroup>
          </Col>
          <Col xs="6" sm="3">
            <FormGroup className="mb-4">
              <Label>Start Date</Label>
              <DateSelector
                maxDate={new Date()}
                todayDate={new Date().toString()}
                name="startDate"
                onValueChange={(date) => handleDateChange(date, 'startDate')}

              />
            </FormGroup>
          </Col>
          <Col xs="6" sm="3">
            <FormGroup className="mb-4">
              <Label>End Date</Label>
              <DateSelector
                maxDate={new Date()}
                todayDate={new Date().toString()}
                name="endDate"
                onValueChange={(date) => handleDateChange(date, 'endDate')}

              />
            </FormGroup>
          </Col>
          {/* <Col xs="6" sm="3">
            <FormGroup className="mb-4">
              <Label>Travel Route</Label>
              <SelectListComponent
                data={travelRoutes}
                valueKey="value"
                textField="label"
                selectValue={selectedTravelRoute}
                onValueChange={onTravelRouteValueChange}
              />
            </FormGroup>
          </Col> */}

          <Col xs="6" sm="1">
            <label>&nbsp;</label>
            <Button className="btn-avi-primary" onClick={() => onSearch()}>
              Search
            </Button>
          </Col>
        </Row>
      </Container>
    </Form>
  );
};

export default WalletPanel;



// WEBPACK FOOTER //
// ./src/views/airline-wallet-history/wallet-panel.js